import {
  EntityStateActionType,
  EntityStateKey,
  EntityStateSetActionCodec,
  EntityStateValue,
  EntityStateViewName,
  IEntityStateSetAction,
} from '@engoo/realtime-protocol/entityState';
import { KeyPathType } from '@engoo/realtime-protocol/keypath';
import { KeyPath } from 'app/models/entityStateSync/keypath';
import { decodeOrThrow } from 'app/utils/ioTs';

export const setEntityState = <
  ViewName extends EntityStateViewName,
  Key extends EntityStateKey<ViewName>,
  Value extends EntityStateValue<ViewName, Key>,
>(
  subpath: KeyPath,
  viewName: ViewName,
  key: Key,
  value: Value,
): IEntityStateSetAction => {
  // While the parameters offer protection, it is not enough to verify
  // that the action meets the criteria of IEntityStateSetAction. Use
  // a type guard below to double check and throw if not.
  const action = {
    type: EntityStateActionType.Set,
    path: [...subpath.map((p) => p.toJS()).toArray(), { type: KeyPathType.View, viewName }],
    key,
    value,
  };

  return decodeOrThrow(EntityStateSetActionCodec, action, (errors) => {
    throw new Error(errors.join('\n'));
  });
};
